export { default } from './CreateIcon';
